import { useQuery } from "@tanstack/react-query";
import { API_URL } from "@/config/api";

export interface ServiceRating {
  serviceId: string;
  average: number;
  count: number;
}

/**
 * Fetches average ratings for ALL services in one request.
 * Returns a Map-like lookup: serviceId → { average, count }
 */
export function useServiceRatings() {
  return useQuery<ServiceRating[]>({
    queryKey: ["/reviews/ratings"],
    queryFn: async () => {
      const res = await fetch(`${API_URL}/reviews/ratings`);
      if (!res.ok) return [];
      return res.json();
    },
    staleTime: 5 * 60 * 1000, // cache for 5 minutes
  });
}

/**
 * Helper to look up a single service's rating from the list.
 */
export function getRating(
  ratings: ServiceRating[] | undefined,
  serviceId: string
): { average: number; count: number } | null {
  if (!ratings) return null;
  const found = ratings.find((r) => r.serviceId === serviceId);
  if (!found || found.count === 0) return null;
  return { average: found.average, count: found.count };
}
